import React, { useEffect }  from "react";
import Navigation from "../../Components/Navigation/Navigation";
import Banner from "../../Components/Banner";
import Terms from "../../Assets/Images/Banner/cookie.jpg";
import "./FooterPages.css";
import GreenStamp from "../../Assets/Images/AboutUs/zen-stamp.svg";
import Footer from "../../Components/Navigation/Footer";

function CookiePolicy() {

  useEffect(() => {
    document.title = "Cookie Policy| Zen Homes";
  }, []);

  return (
    <div className="informationContainer cookiePolicy">
      <Navigation linkColor="black" submenuColor="black" menuIconColor="black"/>
      <Banner title="Cookie Policy" backgroundImage={Terms}/>
      <div className="informationContainer">
        <div className="intro">
          <img src={GreenStamp} className="termsStamp" alt="Zen Stamp" />
        
          <p>
            At Zen Homes, we value your privacy and are committed to being
            transparent about how we collect and use information through the use
            of cookies. This Cookie Policy explains what cookies are, how we use
            them, and how you can manage them.
          </p>

          <h3>What Are Cookies?</h3>
          <p>
            Cookies are small text files that are placed on your device (such as
            your computer, tablet, or smartphone) when you visit a website.
            These files store information about your interactions with the site,
            such as your preferences, browsing history, and login details.
            Cookies help us improve the functionality and performance of our
            website.
          </p>

          <h3>Types of Cookies We Use</h3>
          <p>
            We use different types of cookies for various purposes. Essential
            cookies are necessary for the operation of our website. Without
            these cookies, the site may not function correctly. They are
            typically set in response to actions such as logging in, filling out
            forms, or setting preferences. Performance cookies allow us to
            analyse how visitors interact with our website, helping us
            understand areas of improvement and enabling us to improve user
            experience. Functional cookies allow us to remember your preferences
            and choices to provide a more personalised experience. For example,
            they may remember your language preferences or the region you are
            in. Targeting cookies are used to deliver advertisements that are
            more relevant to you based on your interests. These cookies can also
            limit the number of times you see an advertisement and help measure
            the effectiveness of marketing campaigns.
          </p>

          <h3>How We Use Cookies</h3>
          <p>
            Cookies are used to improve your user experience by remembering your
            preferences and settings. They help us analyse website traffic and
            usage patterns to enhance the performance of our website. We also
            use cookies to customise the content and advertisements you see
            based on your interests and to enable certain features such as
            social media sharing or comments.
          </p>

          <h3>Third-Party Cookies</h3>
          <p>
            We may use third-party services (such as Google Analytics, social
            media platforms, or advertising networks) that also place cookies on
            your device. These cookies are subject to the respective third
            parties' privacy policies. Zen Homes does not control or access
            these cookies and encourages you to review their cookie policies
            directly.
          </p>

          <h3>Managing Cookies</h3>
          <p>
            You have control over how cookies are set on your device. You can
            manage or block cookies through your browser settings. Please note
            that blocking certain types of cookies may impact your experience on
            our website and limit the functionality of certain features. To
            manage cookies in your browser, you can typically find options to
            disable cookies in the "Privacy" or "Settings" section of your
            browser. You can also configure your browser to notify you when
            cookies are being set. If you wish to opt-out of certain targeted
            advertising cookies, you can visit the Network Advertising
            Initiative (NAI) or the Digital Advertising Alliance (DAA) websites
            to learn more and manage your preferences.
          </p>

          <h3>Consent</h3>
          <p>
            By continuing to use our website, you consent to the use of cookies
            as described in this policy. You can withdraw your consent at any
            time by adjusting your cookie settings or blocking cookies via your
            browser.
          </p>

          <h3>Updates to This Cookie Policy</h3>
          <p>
            Zen Homes may update this Cookie Policy from time to time. Any
            changes will be posted on this page with the updated date. We
            encourage you to review this page periodically for any changes. Your
            continued use of our website after the posting of any updates
            constitutes your acceptance of those changes.
          </p>

          <h3>Contact Us</h3>
          <p>
            If you have any questions about our use of cookies or this Cookie
            Policy, please feel free to contact us at 020 8191 0907.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CookiePolicy;
